import { useEffect } from 'react'

// `messages` carries the backend's own words when it explained the failure;
// without it the dialog keeps its original generic wording.
const FormErrorDialog = ({ click, messages = [] }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return (
    <>
      <div
        onClick={click}
        className="fixed inset-0 z-10 flex items-center justify-center w-full h-full bg-black-default/10"
      >
        <div className="flex flex-col items-center justify-between w-full h-full px-5 py-10 overflow-auto text-center text-white md:w-3/5 md:h-2/4 bg-blue">
          <h4 className="pt-32 text-2xl md:text-5xl mb-11 md:p-0">
            {messages.length > 0
              ? 'We could not send your request.'
              : 'An error occurred when sending your message.'}
          </h4>
          {messages.length > 0 ? (
            <ul className="mb-8 text-xl leading-8 md:text-2xl">
              {messages.map(message => (
                <li key={message}>{message}</li>
              ))}
            </ul>
          ) : (
            <p className="mb-8 text-xl leading-8 md:text-3xl">
              Please try again in a few minutes.
            </p>
          )}
          <button
            onClick={click}
            className="w-48 px-12 py-2 text-lg font-medium text-white h-14 bg-orange"
          >
            Try Again
          </button>
        </div>
      </div>
    </>
  )
}

export default FormErrorDialog
